import { FC, ReactNode } from 'react';
import { Receipt, Time } from 'react-ionicons';
import LocationIcon from 'screens/AccessExpressV3/BaseComponents/LocationIcon';
import { formatAddress } from './utils';

const RebillBody = ({
  location,
}: {
  location?: {
    address1: string;
    address2?: string | null;
    city: string;
    state: string;
    zip_code: string;
  };
}) => {
  return (
    <div className="flex flex-col gap-2">
      {location && (
        <div className="flex w-full items-center justify-center gap-2 text-center">
          <LocationIcon width="16px" height="16px" color="#94A3B8" />
          <span className="text-base font-bold text-content-base-default">
            {formatAddress(location)}
          </span>
        </div>
      )}
      <div className="flex flex-wrap justify-center gap-8">
        <RebillDetails
          icon={<Receipt width="32px" height="32px" color="currentColor" />}
          title="One bill"
          desc="Granite consolidates all your telecom services into a single streamlined invoice."
        />
        <RebillDetails
          icon={<Time width="32px" height="32px" color="currentColor" />}
          title="Vendor free"
          desc="We handle vendor coordination so you don’t have to."
        />
        <RebillDetails
          icon={<p className="text-[28px] font-bold leading-[28px]">$</p>}
          title="Track & save"
          desc="Detailed reporting to monitor usage and uncover long-term savings."
        />
      </div>
    </div>
  );
};

export default RebillBody;

interface RebillDetailsProps {
  icon: ReactNode;
  title: string;
  desc: string;
}

const RebillDetails: FC<RebillDetailsProps> = ({ icon, title, desc }) => (
  <div className="max-w-[271px] rounded bg-[linear-gradient(103deg,_#7E77B3_7.1%,_#8989FF_27.23%,_#6C9DFF_48.11%,_#78CFDA_69.15%,_#9FF4A9_90.11%)] p-0.5 shadow-[0px_4px_4px_0px_rgba(0,_0,_0,_0.25)]">
    <div className="relative z-10 h-full bg-background-base-surface-2">
      <div className="flex h-full flex-col gap-4 rounded bg-[linear-gradient(90deg,_rgba(126,_119,_179,_0.08)_62.59%,_rgba(137,_137,_255,_0.08)_71.66%,_rgba(108,_157,_255,_0.08)_81.07%,_rgba(120,_207,_218,_0.08)_90.55%,_rgba(159,_244,_169,_0.08)_100%)] px-8 pb-4 pt-8">
        <div className="text-white">{icon}</div>
        <p className="text-2xl font-bold text-white">{title}</p>
        <p className="text-base font-semibold text-[#D9D9D9]">{desc}</p>
      </div>
    </div>
  </div>
);
